import { Helmet } from "react-helmet-async";
import { useSearchParams } from "react-router-dom";
import { WaveBackground } from "@/components/main-page/WaveBackground";

export function ArticleOgPage() {
  const [params] = useSearchParams();
  const title = params.get("title") ?? "Insights";
  const category = params.get("category") ?? "";

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div
        style={{
          width: 1200,
          height: 630,
          position: "relative",
          overflow: "hidden",
          background: "#0a0a0a",
        }}
      >
        <div style={{ position: "absolute", inset: 0, opacity: 0.6 }}>
          <WaveBackground scrollProgress={0} />
        </div>

        <div
          style={{
            position: "relative",
            zIndex: 1,
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 28,
            padding: "60px 80px",
          }}
        >
          <img
            src="/logo-og.svg"
            alt="COSX"
            style={{ height: 36 }}
          />
          {category && (
            <span
              style={{
                fontFamily: "var(--font-mono)",
                fontSize: 14,
                letterSpacing: "0.1em",
                textTransform: "uppercase",
                color: "rgba(255,255,255,0.4)",
                border: "1px solid rgba(255,255,255,0.15)",
                padding: "4px 12px",
              }}
            >
              {category}
            </span>
          )}
          <h1
            style={{
              fontFamily: "var(--font-display)",
              fontSize: title.length > 60 ? 36 : 44,
              fontWeight: 300,
              letterSpacing: "-0.01em",
              color: "rgba(255,255,255,0.9)",
              textAlign: "center",
              maxWidth: 800,
              lineHeight: 1.3,
              margin: 0,
            }}
          >
            {title}
          </h1>
          <span
            style={{
              fontFamily: "var(--font-mono)",
              fontSize: 13,
              color: "rgba(255,255,255,0.3)",
              letterSpacing: "0.05em",
            }}
          >
            cosx.co/insights
          </span>
        </div>
      </div>
    </>
  );
}
